<div class="container">
    <div class="icon">
        <mat-icon aria-hidden="false" aria-label="Example error icon" fontIcon="error"></mat-icon>
    </div>
    <div class="content">{{data}}</div>
</div>